<template>
  <div class="usWrap">
    <div class="usCont">
      <div class="headTitle">
        <div class="title_img"></div>
        <p>关于我们</p>
        <div class="title_img"></div>
      </div>
      <div class="content btmBrief" v-html="content"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AboutUs",
  props:['item'],
  computed:{
    content(){
      let str = this.item.data['description']
      return str
      // return str.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&').replace(/&quot;/g, '"').replace(/&apos;/g, "'");
    }
  }
}
</script>

<style lang="stylus" scoped>
@import "../static/css/global.styl"
.usWrap
  position relative
  .usCont
    width 100%
    margin-top 26px
    position relative
    border-radius 10px
    .headTitle
      display flex
      align-items center
      justify-content center
      & > p
        margin 0 10px
        font-size 14px
      .title_img
        width 48px
        height 16px
        background url("https://sucai.weizaojiao.cn/img/org-title-info.png") no-repeat center
        background-size 100% auto
        &:last-of-type
          transform rotate(-180deg)
    .content
      width 100%
      min-height 200px
      padding 10px
      >>>img
        width 100%
        height auto
</style>
